export default __webpack_public_path__ + "7198870ea4289313ea1213a661e32267.svg";